// extracted by mini-css-extract-plugin
export default {"button":"qsqLajoH_hrxsrUokGtu"};